import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from './Icons';
export function HeroSection() {
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden pt-12" aria-label="Hero" data-id="element-113">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-114">
        <img src="https://cdn.magicpatterns.com/uploads/dwc6iqVK19yJEFV3kPnHNH/Hero_1-1.png" alt="" className="w-full h-full object-cover" aria-hidden="true" data-id="element-115" />
        {/* Dark overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-[#0a0f0a]" data-id="element-116" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/50" data-id="element-117" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 text-center py-20" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        ease: 'easeOut'
      }} data-id="element-119">
          {/* Eyebrow */}
          <p className="font-sans text-xs sm:text-sm tracking-[0.25em] uppercase text-gold/80 mb-8" data-id="element-120">
            The Longevity Bowl
          </p>

          {/* Main Headline */}
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-cream leading-[1.15] mb-8" data-id="element-121">
            "I Fed My Giant the <em className="text-gold" data-id="element-122">'Best'</em> Kibble for
            Years...
            <br className="hidden md:block" data-id="element-123" /> And He Was Still{' '}
            <span className="text-urgency-red-bright" data-id="element-124">Dying</span> from Within."
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.3,
        ease: 'easeOut'
      }} data-id="element-125">
          {/* Subheadline */}
          <p className="font-sans text-base sm:text-lg md:text-xl text-cream/80 leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-126">
            How to add{' '}
            <span className="font-semibold text-gold" data-id="element-127">3 to 5 extra years</span>{' '}
            to your large breed's life using{' '}
            <span className="font-semibold text-cream" data-id="element-128">
              $2 supermarket "toppers"
            </span>
            —even if you have zero time to cook.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} data-id="element-129">
          {/* CTA hint */}
          <a href="#pricing" className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-gold text-bg-primary font-sans font-bold text-sm sm:text-base rounded tracking-wide transition-all duration-300 hover:bg-gold-bright hover:shadow-[0_0_30px_rgba(200,168,78,0.3)]" aria-label="Get the blueprint now" data-id="element-130">
            GET THE BLUEPRINT
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-131">
        <a href="#pain" aria-label="Scroll down" data-id="element-132">
          <ArrowDownIcon className="w-6 h-6 text-cream/40" data-id="element-133" />
        </a>
      </motion.div>
    </section>;
}